"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getThemeColor = void 0;
function getThemeColor(_a) {
    var theme = _a.theme, color = _a.color, shade = _a.shade;
    var primaryShades = theme.colors[theme.primaryColor];
    return color in theme.colors ? theme.colors[color][shade] : primaryShades[shade];
}
exports.getThemeColor = getThemeColor;
